import { z } from "zod";

export const campaignUploadFormSchema = z.object({
  file: z
    .custom<File | null>((file) => file === null || file instanceof File)
    .refine((file) => file instanceof File, {
      message: "validationMessages.requiredMessage",
    })
    .refine((file) => {
      if (!(file instanceof File)) {
        return false;
      }

      const extension = file.name.split(".").pop()?.toLowerCase();
      return extension === "csv" || extension === "xlsx";
    }, {
      message: "campaigns.upload.validation.invalidExtension",
    }),
});

export type TCampaignUploadSchemaData = z.infer<typeof campaignUploadFormSchema>;
